import { toast } from "sonner";
import { XCircle, AlertTriangle, CheckCircle2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { MatchPanel } from "@/components/OpportunityView";

export const IssueList = ({ checks }) => (
  <div className="space-y-2" data-testid="checks-list">
    {checks.ready && <p className="flex items-center gap-2 text-sm text-teal-800" data-testid="checks-ready"><CheckCircle2 className="h-4 w-4" />No blocking issues.</p>}
    {checks.blocking.map((b) => <p key={b} className="flex gap-2 text-sm text-red-800" data-testid="check-blocking"><XCircle className="mt-0.5 h-4 w-4 shrink-0" />{b}</p>)}
    {checks.warnings.map((b) => <p key={b} className="flex gap-2 text-sm text-amber-800" data-testid="check-warning"><AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />{b}</p>)}
  </div>
);

export default function ChecksPanel({ app, sources, locked, reload }) {
  const docs = sources.filter((s) => s.type === "document");
  const toggle = async (ref) => {
    const next = app.documents.includes(ref) ? app.documents.filter((d) => d !== ref) : [...app.documents, ref];
    try {
      await api.put(`/applications/${app.id}`, { documents: next });
      reload();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="grid gap-6 lg:grid-cols-2">
      <section className="card p-6"><h2 className="mb-4 font-semibold text-[#0B192C]">Completeness checks</h2><IssueList checks={app.checks} /></section>
      <div className="space-y-6">
        <section className="card p-6" data-testid="submission-documents">
          <h2 className="font-semibold text-[#0B192C]">Documents to include</h2>
          <p className="mt-1 text-xs text-slate-500">Select the exact files that will be submitted or included in the export pack. Upload files on the project's Documents tab.</p>
          <ul className="mt-3 space-y-2">
            {!docs.length && <li className="text-sm text-slate-500">No documents uploaded for this project.</li>}
            {docs.map((d) => (
              <li key={d.ref}><label className="flex items-center gap-3 text-sm"><input type="checkbox" disabled={locked} data-testid={`include-doc-${d.ref}`} checked={app.documents.includes(d.ref)} onChange={() => toggle(d.ref)} className="h-4 w-4 accent-[#0D9488]" />{d.label} <span className="caption">{d.value}</span></label></li>
            ))}
          </ul>
          <h3 className="mt-5 text-sm font-semibold">Checklist</h3>
          <ul className="mt-1 list-disc pl-5 text-sm text-slate-700">{app.template.checklist.map((c) => <li key={c.label}>{c.label} {c.required ? "(required)" : "(optional)"}</li>)}</ul>
        </section>
        {app.checks.eligibility && <MatchPanel match={app.checks.eligibility} />}
      </div>
    </div>
  );
}
